import { orgCalendarDate } from '@/lib/utils/custom-date/custom-date';
import { getOrganizationTimeZone } from '@/lib/utils/custom-date/org-time-zone';
import { attendanceDateClause } from '@/modules/attendance/hr-my-attendance/services/attendance-rules';

/** Today as "YYYY-MM-DD" for the date picker: the day in the organization's time zone, not the
 * device's or UTC's. */
export const todayInOrganization = (
  now: Date = new Date(),
  timeZone: string = getOrganizationTimeZone()
): string => orgCalendarDate(now.toISOString(), timeZone);

/**
 * Gateway filter clause for the food requests of one lunch day ("YYYY-MM-DD"). `RequestedForDate`
 * is date only (that day at 00:00:00 UTC), so the day is matched on its UTC-midnight bounds and
 * never shifted to a time zone.
 */
export const buildLunchDayFilter = (day: string) =>
  /^\d{4}-\d{2}-\d{2}$/.test(day) ? attendanceDateClause(day) : undefined;
